import React from 'react';
import ReactIdswiper from 'react-id-swiper';
import { withTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import './ycProjects.scss';

import imgFaubourg from '@/assets/images/c-full-projects/head-faubourg-home.png';
import imgRoad from '@/assets/images/c-full-projects/head-road-home.png';
import imgBic from '@/assets/images/c-full-projects/head-bic.png';
import imgDether from '@/assets/images/c-full-projects/head-dether.png';
import imgXXE from '@/assets/images/c-full-projects/head-xxe.png';
import imgIsho from '@/assets/images/c-full-projects/head-isho.png';
import imgIrm from '@/assets/images/c-full-projects/head-irm.png';
import { YcProject } from '../YcProject/YcProject';

export const YcProjects = withTranslation(['home'])(
  class YcProjectsClass extends React.PureComponent {
    projects = [
      {
        img: imgFaubourg,
        title: 'Le Faubourg',
        desc: 'Conception du nouveau site internet du restaurant Le Faubourg.',
      },
      {
        img: imgRoad,
        title: 'Hit the road',
        desc: 'Conception de la nouvelle identité graphique de la plateforme Hit the road, App et site web.',
      },
      {
        img: imgBic,
        title: 'Shop BIC',
        desc: 'Développement d’une plateforme de personnalisation de briquets.',
      },
      {
        img: imgDether,
        title: 'Dether.io',
        desc:
          'Conception d’une plateforme de création de wallet pour l’achat et vente de cryptomonnaies.',
      },
      {
        img: imgXXE,
        title: 'XXE',
        desc: 'Création de la plateforme XXE qui met en relation des travailleurs indépendants (freelances) et des clients.',
      },
      {
        img: imgIsho,
        title: 'Isho Immo',
        desc:
          'Conception et développement du site internet (espace client et administrateur) et de l’identité graphique de l’agence.',
      },
      {
        img: imgIrm,
        title: 'Plateforme IRM',
        desc:
          'Elaboration d’un outil intranet s’intégrant dans un écosystème et répondant à des besoins spécifiques.',
      },
    ];

    swiperOptions = {
      speed: 700,
      loop: true,
      simulateTouch: true,
      slidesPerView: 3,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        waitForTransition: true,
      },
    };

    swiperRef = null;

    renderSlider() {
      return (
        <ReactIdswiper {...this.swiperOptions}>
          {this.projects.map((project, index) => (
            <div key={index} className="swipe-content">
              <YcProject project={project} />
            </div>
          ))}
        </ReactIdswiper>
      );
    }
    renderSliderMobile() {
      return (
        <div>
          {this.projects.slice(0, 3).map((project, index) => (
            <div className="swipe-content" key={index}>
              <YcProject project={project} />
            </div>
          ))}
        </div>
      );
    }

    render() {
      const { t } = this.props;

      return (
        <div className="yc-projects">
          <h2 dangerouslySetInnerHTML={{ __html: t(`home.projects.title`) }}></h2>
          <p className="desc">{t(`home.projects.desc`)}</p>
          <div className="swiper">{this.renderSlider()}</div>
          <div className="swiper-mobile">{this.renderSliderMobile()}</div>

          <NavLink to="/projects" className="btn btn-outline-primary btn-lg d-block mx-auto">
            {t(`home.projects.btn`)}
          </NavLink>
        </div>
      );
    }
  },
);
